var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.is_claimed)?_c('div',{staticClass:"text-center mb-16"},[_vm._v("\n        "+_vm._s(_vm.owner_text_trans)+"\n        "),_c('a',{staticClass:"tw-btn",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.claim_company(_vm.company_id)}}},[_vm._v("\n            "+_vm._s(_vm.claim_trans)+"\n        ")]),_vm._v(" "),_c('hr')]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c5623c0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ClaimRestaurant.vue
// module id = IbHd
// module chunks = 0